
<app-aso-hdr-btn [grpAsoId] = grpAsoId [asoHdr] = asoHdr > </app-aso-hdr-btn>
<app-chptr-src-slctr  [grpAsoId] = grpAsoId [refHdr]=asoHdr >  </app-chptr-src-slctr>

